module.exports = __webpack_public_path__ + "static/media/chatbot.59b19ffc.svg";